module.exports = __webpack_public_path__ + "img/red_016.1f4af46c.png";